import { useMutation, useQueryClient } from '@tanstack/react-query';
import { boxInvitationsQuery } from 'networking/mindfeed/queries/boxInvitations';
import { notify, NotificationType } from 'xstate/actors/NotificationActor';
import { deleteBoxInvitation } from 'networking/mindfeed/services/box.service';
import { BoxId } from 'models/Box';
import { InvitationId } from 'models/Invitation';

type Variables = {
  boxId: BoxId;
  invitationId: InvitationId;
};

const useDeleteBoxInvitation = () => {
  const queryClient = useQueryClient();

  const onSuccessCallback = async (_data: void, variables: Variables) => {
    // Invalidate invitations
    queryClient.invalidateQueries({
      queryKey: boxInvitationsQuery(variables.boxId).queryKey,
    });

    // Notify User
    notify(NotificationType.BOX_INVITATION_DELETED);
  };

  return useMutation<void, Error, Variables>({
    mutationFn: (variables) =>
      deleteBoxInvitation(variables.boxId, variables.invitationId),
    onSuccess: onSuccessCallback,
  });
};

export default useDeleteBoxInvitation;
